import {
    Image,
    useAppDisplayModeContext,
    useStyles,
    Flex,
    Subheader,
    useTheme,
} from '@archipro-design/aria';

import * as S from './AboutBanner.style';
import { pxToRem } from '@archipro-design/aria';

import {
    ABOUT_BANNER_SIZE,
    ABOUT_BANNER_SIZE_MOBILE,
} from '@modules/professional/config/constants';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import { BoostResolutionOverlay } from '@modules/page-builder/component/common/upscale-warning/BoostResolutionOverlay';

interface AboutBannerProps {
    bannerImage: string | null;
    /** LibraryImage ID for the current banner — used by BoostResolutionOverlay */
    bannerId: number | null;
    /** Whether this banner image was previously upscaled */
    wasUpscaled?: boolean;
    title: string;
}

export const AboutBanner: React.FC<AboutBannerProps> = ({
    bannerImage,
    bannerId,
    wasUpscaled,
    title,
}) => {
    const theme = useTheme();
    const { mobile: isMobile } = useAppDisplayModeContext();

    const { css } = useStyles();

    const bannerSize = isMobile ? ABOUT_BANNER_SIZE_MOBILE : ABOUT_BANNER_SIZE;

    if (!bannerImage) {
        return (
            <Flex className={css(S.Banner)} hAlign="center" vAlign="center">
                <Subheader
                    variant="03"
                    variables={{
                        color: theme.siteVariables.colors.grey['300'],
                    }}
                >
                    About image
                </Subheader>
            </Flex>
        );
    }

    const imageElement = (
        <Image
            src={bannerImage}
            width={pxToRem(bannerSize)}
            height={pxToRem(bannerSize)}
            layout="fill"
            objectFit="cover"
            sizes={getImagesSizes({
                desktop: ABOUT_BANNER_SIZE,
                mobile: ABOUT_BANNER_SIZE_MOBILE,
            })}
            alt={title}
        />
    );

    return (
        <div className={css(S.Banner)}>
            {bannerId ? (
                <BoostResolutionOverlay
                    libraryImageId={bannerId}
                    currentImageUrl={bannerImage}
                    displayWidth={bannerSize}
                    displayHeight={bannerSize}
                    wasUpscaled={wasUpscaled}
                    className="h-full w-full"
                >
                    {imageElement}
                </BoostResolutionOverlay>
            ) : (
                imageElement
            )}
        </div>
    );
};
